import { render, staticRenderFns } from "./DetachDialog.vue?vue&type=template&id=0371b926"
import script from "./DetachDialog.vue?vue&type=script&lang=js"
export * from "./DetachDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports